<template>
  <v-card raised class="fill-height">
    <v-container class="fill-height overflow-y-auto pr-6 py-0">
      <v-row class="fill-height">
        <v-col class="pr-0 py-0">
          <v-card-title class="pr-0">
            {{ $t('dialogs.notification.title') }}
            <v-spacer/>
            <v-btn
              outlined
              color="primary"
              :disabled="notifications.length === 0"
              @click="dismissAllNotifications"
            >
              {{ $t('actions.dismissAll') }}
            </v-btn>
          </v-card-title>
          <v-card-subtitle v-if="isMobile()" class="subtitle-1">
            <span class="text--disabled">
             {{ $t('notifications.swipeMessage') }}
              <v-icon>exit_to_app</v-icon>
            </span>
          </v-card-subtitle>
          <v-divider/>
          <v-card-subtitle v-if="notifications.length === 0" style="text-align: center">
            {{ $t('dialogs.notification.message') }}
          </v-card-subtitle>
          <v-card
            v-for="notification in notifications" :key="notification.notificationId"
            elevation="1"
            class="my-3"
          >
            <v-system-bar
              :color="getNotificationColor(notification.notificationType.priority)"
              height="6"
            />
            <v-toolbar flat>
              <v-toolbar-title>
                {{ notification.notificationType.notificationHeading }}
              </v-toolbar-title>
              <v-spacer/>
              <v-tooltip left :disabled="isMobile()">
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    text
                    v-on="on"
                    @click="dismissNotification(notification.notificationId)"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </template>
                <span>{{  $t('actions.dismiss') }}</span>
              </v-tooltip>
            </v-toolbar>
            <v-banner>
              <v-icon
                slot="icon"
                :color="getNotificationColor(notification.notificationType.priority)"
              >
                {{ notification.notificationType.icon }}
              </v-icon>
              <span class = "notificationMessage" v-html="getNotificationBody(notification.body)"/>
              <v-spacer/>
              {{ notification.positionDescription }}
              <template v-slot:actions>
                <v-btn
                  dark
                  color="primary"
                  :disabled="!notification.linkEnabled"
                  @click="navToNotificationRoute(notification)"
                >
                  {{ notification.notificationType.linkText }}
                </v-btn>
              </template>
            </v-banner>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';

import constants from '@/constants';
import EventBus from '@/event-bus';
import hasAppDialog from '@/mixins/hasAppDialog';
import isMobile from '@/mixins/displayAdaptable';

export default {
  name: 'NotificationList',
  mixins: [hasAppDialog, isMobile],

  props: {
    notifications: {
      type: Array,
      required: true,
    },
  },

  methods: {
    ...mapActions(['postNotificationDismissed', 'postAllNotificationsDismissed']),

    getNotificationColor(notificationTypePriority) {
      switch (notificationTypePriority) {
        case constants.Notifications.Priority.HIGH: {
          return constants.Notifications.Colors.HIGH;
        }
        case constants.Notifications.Priority.MED: {
          return constants.Notifications.Colors.MED;
        }
        case constants.Notifications.Priority.LOW: {
          return constants.Notifications.Colors.LOW;
        }
        default: {
          return constants.Notifications.Colors.INFO;
        }
      }
    },

    getNotificationBody(body) {
      let returnBody = body.replace(/\n/, '<br/>');
      returnBody = returnBody.replace('<li>', '<li class="notificationMessageListItem">');
      return returnBody;
    },

    navToNotificationRoute(notification) {
      const timePairId = notification.notificationType.id
      !== constants.Notifications.NotificationTypeId.MISSED_CLOCKOUT
        ? notification.timePairId : null;

      if (this.$route.name !== notification.notificationType.linkPage) {
        this.$router.push(
          {
            name: notification.notificationType.linkPage,
          },
        ).then(() => {
          if (timePairId) {
            this.emitNotificationActionEvent(timePairId, notification);
          }
        });
      } else if (timePairId) {
        this.emitNotificationActionEvent(timePairId, notification);
        this.$emit('close');
      }
    },

    emitNotificationActionEvent(timePairId, notification) {
      EventBus.$emit(
        'time-pairs:notification-action',
        { timePairId, type: notification.notificationType.id },
      );
    },

    dismissNotification(notificationId) {
      this.postNotificationDismissed(notificationId);
    },

    dismissAllNotifications() {
      this.showAppConfirmDialog({
        message: this.$t('dialogs.notification.clearMessage'),
        confirmHandler: this.postAllNotificationsDismissed,
      });
    },
  },
};
</script>
